import { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import { useAuthorization } from "../../../hooks/useAuthorization";
import {
  getAccount,
  unsetSelectedAccount,
} from "../../../features/accountsSlice";
import AddChartAccount from "./AddChartAccount";
import DeleteChartAccount from "./DeleteChartAccount";
import Loading from "../../../components/loading/Loading";
import MainContainer from "../../../components/container/MainContainer";
import Modal from "../../../components/modal/Modal";
import { ChevronLeft, Save, Trash2 } from "lucide-react";
import { openModal } from "../../../features/modalSLice";
import TextContainer from "../../../components/text/TextContainer";
import PageTitle from "../../../components/titles/PageTitle";
import useCustomBackButton from "../../../hooks/useCustomBackButton";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const SingleChartAccount = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const modalContent = useSelector((state) => state.modal.content);
  const account = useSelector((state) => state.accounts.selectedAccount);
  const loading = useSelector((state) => state.accounts.load.getAccount);

  const openEditAccountModal = (edit, id) => {
    dispatch(openModal(<AddChartAccount edit={edit} id={id} />));
  };

  const openDeleteAccountModal = (id) => {
    dispatch(openModal(<DeleteChartAccount id={id} />));
  };

  useCustomBackButton("/settings/accounts");

  useLayoutEffect(() => {
    dispatch(getAccount(id));

    return () => {
      dispatch(unsetSelectedAccount());
    };
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <PageTitle title={"Account - " + account.name} />
      <div className="bg-content  border border-bkg2 rounded-md p-7 mb-5 !text-text-1/55">
        <TextContainer label="Name" content={account.name} />
        <TextContainer label="Account Type" content={account.account_type} />
        <TextContainer label="Category" content={account.account_category} />
        <TextContainer label="Currency" content={account.currency} />
        <TextContainer
          label="Balance"
          content={`${account.currency_id ? account.symbol : ""} ${
            account.balance
          }`}
        />
        <TextContainer label="Code" content={account.code} />
        <TextContainer label="Project Account" content={account.project_text} />
      </div>
      <div className="p-4 border border-bkg2 rounded-md flex justify-between items-center">
        <Link to="/settings/accounts" className="cancel-rss-btn">
          <ChevronLeft size={18} /> Back
        </Link>
        <div className="flex gap-3">
          <button
            onClick={(e) => openEditAccountModal(true, id)}
            disabled={!isAuthorized("accounts", "update")}
            className="add-rss-btn"
          >
            <Save size={18} />
            Edit
          </button>
          <button
            onClick={(e) => openDeleteAccountModal(id)}
            disabled={!isAuthorized("accounts", "delete") || account.project}
            className="delete-rss-btn"
          >
            <Trash2 size={18} />
            Delete
          </button>
        </div>
      </div>
    </MainContainer>
  );
};

export default SingleChartAccount;
